/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/filter'
export default icon
